function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Attributes } from '@leverege/ui-attributes';
import React from 'react';
class ImagineGroupName extends React.Component {
  async componentDidMount() {
    const {
      data,
      dispatch,
      context
    } = this.props;
    const {
      clientProps: {
        relationship,
        delegate
      }
    } = context;
    const original = this.getData();
    const imagineGroup = Attributes.get('imagineGroup', relationship.objectType, original);
    if (!imagineGroup) {
      await dispatch(delegate.getImagineGroup(data?.id));
    }
  }
  getData() {
    const {
      data,
      object
    } = this.props;
    return data?.row?.original || object?.data;
  }
  render() {
    const {
      data,
      context,
      style
    } = this.props;
    const original = this.getData();
    const {
      renderer,
      clientProps: {
        relationship
      }
    } = context;
    const imagineGroupName = Attributes.get('imagineGroupName', relationship.objectType, original);
    if (renderer.renderCell) {
      return renderer.renderCell({
        ...data,
        value: imagineGroupName
      }, this.props, context);
    }
    return renderer.getValueComponent([imagineGroupName], style);
  }
}
export default function toExport(data, props, context) {
  return /*#__PURE__*/React.createElement(ImagineGroupName, _extends({}, props, {
    data: data,
    context: context
  }));
}